<template>
  <v-dialog
    :model-value="modelValue"
    max-width="900"
    persistent
    :scrim="!isExportingPdf"
    :style="isExportingPdf ? 'position: fixed; left: -9999px; opacity: 0;' : ''"
    @update:model-value="(val) => emit('update:modelValue', val)"
  >
    <v-card color="#2B2D33">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>采购单预览</span>
        <v-btn icon="mdi-close" variant="text" @click="emit('update:modelValue', false)" />
      </v-card-title>
      <v-card-text style="padding: 16px; max-height: 80vh; overflow-y: auto; background: #f5f5f5;">
        <div class="pdf-preview-wrapper">
          <div class="purchase-pdf-container" id="purchase-pdf-content" :style="pdfLayoutStyle">
            <div
              v-for="(page, pageIdx) in renderPaginatedItemList"
              :key="'page-' + pageIdx"
              class="purchase-pdf-page"
            >
              <div class="pdf-header-container">
                <div class="pdf-header">
                  <div class="header-left">
                    <img :src="jfLogo" alt="logo" class="company-logo" />
                    <div class="company-info">
                      <div class="company-name-row">
                        <span class="company-name">{{ previewPdfData.order?.paymentCompany === '优罗莎' ? '优罗莎家具(昆山)有限公司' : '上海江丰家具集团有限公司' }}</span>
                        <!-- <span class="order-tag">{{ previewPdfData.order?.purchaseType === 0 ? '实物采购单' : '服务采购单' }}</span> -->
                        <span class="order-tag" style="width:45px;">{{ getPaymentMethodLabel(previewPdfData.order?.paymentType) }}</span>
                      </div>
                      <div class="order-numbers">
                        <span>采购单号</span>
                        <span class="order-no">{{ previewPdfData.order?.purchaseOrderNo || '/' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="header-right">
                    <span class="page-info">第{{ pageIdx + 1 }}页/共{{ renderPdfTotalPages }}页</span>
                  </div>
                </div>
                <div class="pdf-order-info">
                  <div class="info-columns">
                    <div class="info-left">
                      <div class="info-item">
                        <span class="info-label">销售单号</span>
                        <span class="info-value">{{ previewPdfData.order?.code || previewPdfData.order?.so || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">项目名称</span>
                        <span class="info-value">{{ previewPdfData.order?.project || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">下单时间</span>
                        <span class="info-value">{{ formatPdfDate(previewPdfData.order?.createTime) }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">采购人</span>
                        <span class="info-value">{{ previewPdfData.order?.user?.nickname || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">收货仓库</span>
                        <span class="info-value">{{ previewPdfData.order?.warehouseAddress || '/' }}</span>
                      </div>
                    </div>
                    <div class="info-right">
                      <div class="info-item">
                        <span class="info-label">供应商名称</span>
                        <span class="info-value">{{ previewPdfData.order?.vendor?.companyName || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">供应商地址</span>
                        <span class="info-value">{{ previewPdfData.order?.vendor?.supplierAddress || '/' }}</span>
                      </div>
                      <!-- v-if="previewPdfData.order?.purchaseType === 1" -->
                      <div class="info-item" v-if="previewPdfData.order?.deliveryAddress">
                        <span class="info-label">送货地址</span>
                        <span class="info-value">{{ previewPdfData.order?.deliveryAddress || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">联系人</span>
                        <span class="info-value">{{ previewPdfData.order?.vendor?.contactPerson || '/' }}</span>
                      </div>
                      <div class="info-item">
                        <span class="info-label">联系电话</span>
                        <span class="info-value">{{ previewPdfData.order?.vendor?.phone || '/' }}</span>
                      </div>
                      <!-- <div class="info-item">
                        <span class="info-label">税率</span>
                        <span class="info-value">{{ previewPdfData.order?.taxRate ? previewPdfData.order?.taxRate / 100 : 0 }}</span>
                      </div> -->
                      <!-- <div class="info-item">
                        <span class="info-label">结账方式</span>
                        <span class="info-value">{{ getPaymentMethodLabel(previewPdfData.order?.paymentType) }}</span>
                      </div> -->
                    </div>
                  </div>
                  <!-- v-if="previewPdfData.order?.purchaseType === 0" -->
                  <div class="info-item" style="margin-top: 2px;" v-if="previewPdfData.order?.purchaseStandard">
                    <span class="info-label">采购标准</span>
                    <span class="info-value">{{ previewPdfData.order?.purchaseStandard || '/' }}</span>
                  </div>
                </div>
              </div>

              <div class="pdf-table-container" v-if="page.items.length > 0">
                <table class="pdf-table">
                  <thead>
                    <tr>
                      <th style="width: 50px;">项次</th>
                      <th style="width: 150px;" class="text-left">采购项</th>
                      <th style="width: 70px;">类型</th>
                      <th style="width: 130px;" class="text-left">关联产品</th>
                      <th style="width: 60px;">单位</th>
                      <th style="width: 60px;">单价</th>
                      <th style="width: 50px;">数量</th>
                      <th style="width: 80px;">金额</th>
                      <th style="width: 90px;">预定交期</th>
                      <th style="width: 120px;">物料备注</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in page.items" :key="item.id || index">
                      <td class="text-center">{{ getRenderItemIndexOffset(pageIdx) + index + 1 }}</td>
                      <td>
                        <div v-if="item.partName">{{ item.partName }}</div>
                        <div v-if="item.goodsName">{{ item.goodsName }}</div>
                        <div v-if="item.contractCode" class="sub-text">{{ item.contractCode }}</div>
                        <div v-if="item.batch" class="sub-text">{{ item.batch }}</div>
                        <div v-if="item.goodsSpec" class="sub-text">{{ item.goodsSpec }}</div>
                        <div v-if="item.goodsNo" class="sub-text">{{ item.goodsNo }}</div>
                      </td>
                      <td class="text-center">{{ getTypeText(Number(item.itemType)) }}</td>
                      <td class="text-left">
                        <div style="word-break: break-all;word-wrap: break-word;">{{ item.productCodes || '/' }}</div>
                      </td>
                      <td class="text-center">{{ item.unit || '/' }}</td>
                      <td class="text-center">{{ formatNumber(item.price, 4) }}</td>
                      <td class="text-center">{{ formatNormalNumber(item.quantity, 4) }}</td>
                      <td class="text-center">{{ formatNumber(item.totalPrice, 3) }}</td>
                      <td class="text-center">{{ formatPdfDate(item.plannedDeliveryDate) }}</td>
                      <td class="text-center">{{ item.remark || '/' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <template v-if="page.showSummary">
                <div class="pdf-summary">
                  <div class="summary-row">
                    <span class="summary-label">税额：</span>
                    <span class="summary-currency">RMB</span>
                    <span class="summary-amount">{{ formatNumber(previewPdfData.order?.taxAmount, 4) }}</span>
                    <span class="summary-label" style="margin-left: 30px;">合计金额：</span>
                    <span class="summary-currency">RMB</span>
                    <span class="summary-amount">{{ formatNumber(previewPdfData.order?.totalPrice, 4) }}</span>
                    <span class="summary-label" style="margin-left: 30px;">含税总金额：</span>
                    <span class="summary-currency">RMB</span>
                    <span class="summary-amount">{{ formatNumber(previewPdfData.order?.totalAmountWithTax, 4) }}</span>
                  </div>
                </div>

              </template>

              <template v-if="page.showFooterDetails">
                <div class="pdf-remarks">
                  <span class="remarks-title">备注：</span>
                  <span class="remarks-content">{{ previewPdfData.order?.remark || '' }}</span>
                </div>

                <div class="pdf-footer">
                  <div class="footer-row">
                    <div class="footer-item">
                      <span class="footer-label">审核：</span>
                      <span class="footer-value" style="width: 100px;display: inline-block;" />
                    </div>
                    <div class="footer-item" />
                  </div>
                  <div class="footer-row footer-company">
                    <div class="footer-item">
                      <span>{{ previewPdfData.order?.paymentCompany === '优罗莎' ? '优罗莎家具(昆山)有限公司' : '上海江丰家具集团有限公司' }}</span>
                      <div class="stamp-area">公司盖章及日期</div>
                    </div>
                    <div class="footer-item">
                      <span>供应商：{{ previewPdfData.order?.vendor?.companyName || '/' }}</span>
                      <div class="stamp-area">公司盖章及日期</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end flex-wrap ga-2" style="background: #36383D;">
        <v-btn
          color="secondary"
          variant="tonal"
          prepend-icon="mdi-printer"
          @click="handleBrowserPrint"
        >
          浏览器打印（多联纸）
        </v-btn>
        <v-btn color="primary" variant="flat" @click="emit('confirm-export')">确认导出 PDF</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, nextTick, toRefs } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { itemTypeOptions } from '@/constants/contract' 
import { printPurchaseOrderByContentId } from '@/utils/printPurchaseOrder'

const { showError } = useSnackbar()

interface PageData {
  items: any[]
  isFirstPage: boolean
  isLastPage: boolean
  showSummary: boolean
  showFooterDetails: boolean
  pageIndex: number
}

const props = defineProps<{
  modelValue: boolean
  isExportingPdf: boolean
  itemList?: any[]
  paginatedItemList?: PageData[]
  pdfTotalPages?: number
  previewPdfData: any
  jfLogo: string
  getItemIndexOffset?: (pageIndex: number) => number
  formatPdfDate: (timestamp: number | string | undefined) => string
  formatPdfNumber: (num: number | string | undefined) => string
  getPaymentMethodLabel: (value: string | undefined) => string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm-export'): void
}>()

const handleBrowserPrint = async () => {
  await nextTick()
  await nextTick()
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        try {
          printPurchaseOrderByContentId()
        } catch (err: unknown) {
          const msg = err instanceof Error ? err.message : '打印失败'
          showError(msg)
        }
      }, 200)
    })
  })
}

const {
  modelValue,
  isExportingPdf,
  itemList,
  paginatedItemList,
  previewPdfData,
  jfLogo,
  formatPdfDate,
  formatPdfNumber,
  getPaymentMethodLabel
} = toRefs(props)

const formatNumber = (num: number | string | null | undefined, decimals: number = 2) => {
  if (num === null || num === undefined || num === '') {
    return '0'
  }
  // 将字符串转换为数字
  const numberValue = typeof num === 'string' ? parseFloat(num) : num
  // 检查是否为有效数字
  if (isNaN(numberValue)) {
    return '0'
  }
  return numberValue.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals
  })
}

const formatNormalNumber = (num: number | string | null | undefined, decimals: number = 4): string => {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) {
    return ''
  }
  return parseFloat(n.toFixed(decimals)).toString()
}

// PDF版式统一参数（公共管理）
const PDF_PAGE_WIDTH_PX = 794
const PDF_PAGE_MAX_HEIGHT_PX = 1250
const PDF_HEADER_ESTIMATED_HEIGHT_PX = 250
const PDF_TABLE_HEADER_HEIGHT_PX = 42
const PDF_SUMMARY_ESTIMATED_HEIGHT_PX = 56
const PDF_FOOTER_DETAILS_ESTIMATED_HEIGHT_PX = 460
const PDF_ROW_LINE_HEIGHT_PX = 16
const PDF_ROW_SAFE_PADDING_PX = 16

const getTextLines = (text: any, charsPerLine: number) => {
  const raw = String(text ?? '')
  if (!raw) return 1
  const splitByLine = raw.split('\n')
  return splitByLine.reduce((acc, line) => {
    const len = line.length || 1
    return acc + Math.max(1, Math.ceil(len / charsPerLine))
  }, 0)
}

const estimateRowHeight = (item: any) => {
  const materialParts = [
    item?.partName,
    item?.goodsName,
    item?.contractCode,
    item?.batch,
    item?.goodsSpec,
    item?.goodsNo
  ].filter(Boolean)
  const materialLines = Math.max(
    1,
    materialParts.reduce((sum: number, part: string) => sum + getTextLines(part, 14), 0)
  )
  const productCodesLines = getTextLines(item?.productCodes || '/', 12)
  const remarkLines = getTextLines(item?.remark || '/', 10)
  const maxLines = Math.max(materialLines, productCodesLines, remarkLines, 1)
  return Math.max(36, maxLines * PDF_ROW_LINE_HEIGHT_PX + PDF_ROW_SAFE_PADDING_PX)
}

const renderPaginatedItemList = computed<PageData[]>(() => {
  const sourceItems = Array.isArray(itemList.value)
    ? itemList.value
    : (paginatedItemList.value || []).reduce((acc: any[], page: PageData) => {
        if (page && Array.isArray(page.items)) {
          acc.push(...page.items)
        }
        return acc
      }, [])
  if (sourceItems.length === 0) return []

  const pages: PageData[] = []
  let currentItems: any[] = []
  let pageIndex = 0
  let usedHeight = PDF_HEADER_ESTIMATED_HEIGHT_PX + PDF_TABLE_HEADER_HEIGHT_PX

  const pushPage = (isLast = false, showSummary = false, showFooterDetails = false) => {
    pages.push({
      items: currentItems,
      isFirstPage: pageIndex === 0,
      isLastPage: isLast,
      showSummary,
      showFooterDetails,
      pageIndex
    })
    pageIndex += 1
    currentItems = []
    usedHeight = PDF_HEADER_ESTIMATED_HEIGHT_PX + PDF_TABLE_HEADER_HEIGHT_PX
  }

  sourceItems.forEach((item, idx) => {
    const rowHeight = estimateRowHeight(item)
    if (currentItems.length > 0 && usedHeight + rowHeight > PDF_PAGE_MAX_HEIGHT_PX) {
      pushPage(false, false, false)
    }
    currentItems.push(item)
    usedHeight += rowHeight

    // 二次校验：若估算偏小导致超高，当前行回退到下一页，避免拦腰截断
    if (usedHeight > PDF_PAGE_MAX_HEIGHT_PX && currentItems.length > 1) {
      const rollbackItem = currentItems.pop()
      usedHeight -= rowHeight
      pushPage(false, false, false)
      if (rollbackItem) {
        currentItems.push(rollbackItem)
        usedHeight += rowHeight
      }
    }

    if (idx === sourceItems.length - 1) {
      const canPutSummaryOnLastDataPage =
        usedHeight + PDF_SUMMARY_ESTIMATED_HEIGHT_PX <= PDF_PAGE_MAX_HEIGHT_PX
      const canPutFullFooterOnLastDataPage =
        usedHeight + PDF_SUMMARY_ESTIMATED_HEIGHT_PX + PDF_FOOTER_DETAILS_ESTIMATED_HEIGHT_PX <= PDF_PAGE_MAX_HEIGHT_PX

      if (canPutFullFooterOnLastDataPage) {
        pushPage(true, true, true)
      } else if (canPutSummaryOnLastDataPage) {
        pushPage(false, true, false)
        pages.push({
          items: [],
          isFirstPage: false,
          isLastPage: true,
          showSummary: false,
          showFooterDetails: true,
          pageIndex
        })
      } else {
        pushPage(false, false, false)
        pages.push({
          items: [],
          isFirstPage: false,
          isLastPage: true,
          showSummary: true,
          showFooterDetails: true,
          pageIndex
        })
      }
    }
  })

  if (pages.length > 0) {
    pages.forEach((page, idx) => {
      page.isLastPage = idx === pages.length - 1
      if (idx !== pages.length - 1) {
        page.showFooterDetails = false
      }
    })
  }

  return pages
})

const renderPdfTotalPages = computed(() => renderPaginatedItemList.value.length || 1)

const getRenderItemIndexOffset = (pageIndex: number): number => {
  let offset = 0
  for (let i = 0; i < pageIndex; i++) {
    offset += renderPaginatedItemList.value[i]?.items.length || 0
  }
  return offset
}

const getTypeText = (type: number) => {
  const option = itemTypeOptions.find(opt => opt.value === type)
  return  option?.label
}

const pdfLayoutStyle = computed(() => ({
  '--pdf-page-width': `${PDF_PAGE_WIDTH_PX}px`,
  '--pdf-page-max-height': `${PDF_PAGE_MAX_HEIGHT_PX}px`
}))
</script>

<style lang="scss" scoped>
.purchase-pdf-container {
  width: 100%;
  background: #fff;
}

.purchase-pdf-page {
  width: var(--pdf-page-width);
  height: var(--pdf-page-max-height);
  background: #fff;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  font-family: 'Microsoft YaHei', 'SimHei', Arial, sans-serif;
  color: #000;
  page-break-after: always;
  page-break-inside: avoid;
  break-after: page;
  break-inside: avoid;
  margin: 0 auto 40px;
}

.purchase-pdf-page:nth-child(n+1) {
  margin-bottom: 6px;
}

.purchase-pdf-page:last-child {
  page-break-after: auto;
  break-after: auto;
  margin-bottom: 0;
}

.pdf-simple-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(180deg, #f8f8f8 0%, #fff 100%);
  border-bottom: 1px solid #e0e0e0;
  height: 60px;
  box-sizing: border-box;
  margin-top: 6px;
}

.pdf-simple-header .simple-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pdf-simple-header .company-logo-small {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.pdf-simple-header .simple-title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.pdf-simple-header .simple-header-right {
  font-size: 12px;
  color: #000;
}

.pdf-header-container {
  background: url('@/assets/liaodanPdfTop.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 16px;
}

.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.company-logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.company-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.company-name-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.order-tag {
  display: inline-block;
  width: 90px;
  height: 24px;
  line-height: 21px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #000000;
  border-radius: 4px;
  color: #D2475D;
  font-size: 14px;
  font-weight: bold;
}

.order-numbers {
  font-size: 16px;
  color: #000;
}

.order-numbers .order-no {
  font-weight: bold;
  margin-left: 8px;
}

.header-right {
  font-size: 12px;
  color: #000;
}

.pdf-order-info {
  margin-top: 10px;
}

.pdf-order-info .info-columns {
  display: flex;
  gap: 40px;
}

.pdf-order-info .info-left,
.pdf-order-info .info-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pdf-order-info .info-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
}

.pdf-order-info .info-label {
  color: #000;
  min-width: 75px;
  flex-shrink: 0;
  font-weight: bold;
}

.info-right .info-label {
  min-width: 90px;
}

.pdf-order-info .info-value {
  color: #000;
  flex: 1;
  font-weight: 500;
}

.pdf-table-container {
  margin: 0 16px 16px 16px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  border-bottom: none;
  overflow: hidden;
}

.pdf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.pdf-table tr {
  border-bottom: 1px solid #3E4046;
}

.pdf-table th {
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
}

.pdf-table td {
  padding: 4px 0;
  text-align: left;
  vertical-align: middle;
  line-height: 1.1;
  min-height: 32px;
}

.pdf-table th {
  background: #f5f5f5;
  font-weight: bold;
  text-align: center;
  color: #000;
}

.pdf-table td.text-center {
  text-align: center;
}

.pdf-table td.text-right {
  text-align: right;
}

.pdf-table .sub-text {
  font-size: 12px;
  color: #000;
}

.pdf-summary {
  margin: 0 16px;
  padding: 6px 10px;
  // background-color: #EEEEEE;
  border-radius: 4px;
  border: 1px solid #3E4046;
}

.pdf-summary .summary-row {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.pdf-summary .summary-label {
  color: #000;
  font-weight: bold;
}

.pdf-summary .summary-currency {
  color: #000;
  // margin-left: 8px;
  margin-left: 2px;
  font-weight: bold;
}

.pdf-summary .summary-amount {
  font-weight: bold;
  color: #000;
  // margin-left: 8px;
  margin-left: 2px;
  min-width: 80px;
}

.pdf-remarks {
  margin: 0 16px;
  margin-top: 16px;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  max-height: 300px;
  overflow: hidden;
}

.pdf-remarks .remarks-title {
  font-weight: bold;
  font-size: 16px;
}

.pdf-remarks .remarks-content {
  font-size: 16px;
  color: #000;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 12;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pdf-footer {
  margin: 0 16px;
  margin-top: 16px;
  padding: 6px 10px 80px 10px;
  border-radius: 4px;
  border: 1px solid #3E4046;
  height: 140px;
  box-sizing: content-box;
}

.pdf-footer .footer-row {
  display: flex;
  justify-content: space-between;
}

.pdf-footer .footer-row.footer-company {
  margin-top: 6px;
}

.pdf-footer .footer-item {
  flex: 1;
  font-size: 16px;
}

.pdf-footer .footer-label {
  font-weight: bold;
}

.pdf-footer .footer-value {
  color: #000;
  margin-left: 8px;
}

.pdf-footer .stamp-area {
  font-size: 16px;
}
</style>
